import { EventEmitter, Injectable } from '@angular/core';
import { ApiService } from '@uranda/commons';
import { HttpParams } from '@angular/common/http';
import { Country } from '../../../../model/country.model';
import { City } from '../../../../model/city.model';
import { Region } from '../../../../model/region.model';
import { PartnerSearchResult } from '../../../models/partner-search-result.model';
import { District } from '../../../../model/district.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService extends ApiService {

  async getPartners(pageNumber?: number, pageSize?: number, country?: string, region?: string, district?: string, languageSpoken?: string, sortBy?: string, sortOrder?: string): Promise<any> {
    let queryParameters = new HttpParams();
    
    queryParameters = queryParameters
      .append('pageNumber', pageNumber ?? 0)
      .append('pageSize', pageSize ?? 10)
      .append('country', country ?? '')
      .append('region', region ?? '')
      .append('district', district ?? '')
      .append('languagesSpoken', languageSpoken ?? '')
      .append('sortBy', sortBy ?? '')
      .append('sortOrder', sortOrder ?? '')
    return (await (this.get('/v1/partners/search', queryParameters)))
  }

  async getCountries(onlyAvailable: boolean = true): Promise<Country[]> {
    const params = new HttpParams().set('onlyAvailable', onlyAvailable);
    return (await (this.get('/v1/geo/countries', params))).data
  }

  async getRegions(countryId?: string, onlyAvailable: boolean = true): Promise<Region[]> {
    let params = new HttpParams()
      .set('countryId', countryId?.toString() ?? '')
      .set('onlyAvailable', onlyAvailable);
    return (await this.get('/v1/geo/regions', params)).data;
  }

  async getDistrict(regionId?: string, onlyAvailable: boolean = true): Promise<District[]> {
    let params = new HttpParams()
      .set('regionId', regionId?.toString() ?? '')
      .set('onlyAvailable', onlyAvailable);
    return (await this.get('/v1/geo/districts', params)).data;
  }


  searchResult?: PartnerSearchResult;
  onSearchReady: EventEmitter<boolean> = new EventEmitter<boolean>();
}

export interface CurrentSearch {
  country?: Country,
  city?: City,
  region?: Region
}